import { makeActionCreator } from '../../config/store/utils'
import { getEntityReportOptions } from '../../services/config'
import { searchProvider } from '../../services/search'

export const GET_ENTITY_REPORT_OPTIONS = 'GET_ENTITY_REPORT_OPTIONS'
export const GET_ENTITY_REPORT_OPTIONS_ERROR = 'GET_ENTITY_REPORT_OPTIONS_ERROR'
export const GET_ENTITY_REPORT_OPTIONS_SUCCESS = 'GET_ENTITY_REPORT_OPTIONS_SUCCESS'
export const onGetEntityReportOptions = makeActionCreator(GET_ENTITY_REPORT_OPTIONS)
export const onGetEntityReportOptionsError = makeActionCreator(GET_ENTITY_REPORT_OPTIONS_ERROR, 'payload')
export const onGetEntityReportOptionsSuccess = makeActionCreator(GET_ENTITY_REPORT_OPTIONS_SUCCESS, 'payload')
export const onGetEntityReportOptionsThunk = payload => async dispatch => {
  dispatch(onGetEntityReportOptions())

  try {
    const { data } = await getEntityReportOptions({ id: payload.id })
    const [optionsPayload] = data.payload
    const biddingOptions =
      optionsPayload.data?.lic?.map(item => ({
        ...item,
        name: item.year,
        value: item.year
      })) || []
    const orderOptions =
      optionsPayload.data?.oc?.map(item => ({
        ...item,
        name: item.year,
        value: item.year
      })) || []
    return dispatch(onGetEntityReportOptionsSuccess({ biddingOptions, orderOptions }))
  } catch (error) {
    return dispatch(onGetEntityReportOptionsError({ error }))
  }
}
export const GET_ENTITY_REPORT_BUYER_OPTIONS = 'GET_ENTITY_REPORT_BUYER_OPTIONS'
export const GET_ENTITY_REPORT_BUYER_OPTIONS_ERROR = 'GET_ENTITY_REPORT_BUYER_OPTIONS_ERROR'
export const GET_ENTITY_REPORT_BUYER_OPTIONS_SUCCESS = 'GET_ENTITY_REPORT_BUYER_OPTIONS_SUCCESS'
export const onGetEntityReportBuyerOptions = makeActionCreator(GET_ENTITY_REPORT_BUYER_OPTIONS)
export const onGetEntityReportBuyerOptionsError = makeActionCreator(GET_ENTITY_REPORT_BUYER_OPTIONS_ERROR, 'payload')
export const onGetEntityReportBuyerOptionsSuccess = makeActionCreator(
  GET_ENTITY_REPORT_BUYER_OPTIONS_SUCCESS,
  'payload'
)
export const onGetEntityReportBuyerOptionsThunk = payload => async dispatch => {
  dispatch(onGetEntityReportBuyerOptions())

  try {
    const response = await searchProvider({ term: payload.term })
    const buyerOptions = response.data.map(result => ({
      cat: result.sector,
      name: result.name,
      value: result.entcode
    }))

    return dispatch(onGetEntityReportBuyerOptionsSuccess({ buyerOptions }))
  } catch (error) {
    return dispatch(onGetEntityReportBuyerOptionsError({ error }))
  }
}
